import {
  emailHeaderFontSize,
  tableHeaderColour,
  tableWidth,
} from '../pro-report-email-styles';

function ProReportEmailHeading({ utcDateString }: { utcDateString: string }) {
  return (
    <table width={tableWidth} role="presentation">
      <tr>
        <th
          style={{
            margin: 0,
            color: tableHeaderColour,
            fontSize: emailHeaderFontSize,
            fontWeight: 'bold',
          }}
        >
          GlobeView PRO Report
        </th>
      </tr>
      <tr>
        <td
          style={{
            margin: 0,
          }}
        >
          Accurate as of: {utcDateString}
        </td>
      </tr>
    </table>
  );
}

export default ProReportEmailHeading;
